import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/security_settings/pages/RootPage'))

const SecuritySettingsPage = React.lazy(
  () => import('modules/security_settings/pages/SecuritySettingsPage')
)

export const securitySettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.security.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <SecuritySettingsPage />,
        },
      ],
      handle: {
        meta: () => ({
          title: i18n.t('security_settings.title'),
          illustration: 'password-lock',
        }),
      },
    },
  ]
}
